// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__EkrWQ","head":"Table_head__29Kpu","col":"Table_col__2b8op"};